import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Slider.scss'; // Import custom CSS
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Importe os componentes de slides
import NovasLojas from './NovasLojas/NovasLojas';
import Slide2 from './TercaDobro/TercaDobro';
// import Slide3 from './Blackfriday1/Blackfriday1';
import Slide4 from './SejaFranqueado/SejaFranqueado';
// import Slide1 from './Blackfriday2/Blackfriday2';
// import Slide1 from './Camarao/Camarao';
// import Slide3 from './Cupom20/Cupom20';  // Novo componente Slide3


// Defina a lista de slides para desktop e mobile
const slides = [<NovasLojas/>, <Slide2/>, <Slide4/>]; // Adicionando Slide2 e Slide3
const mobileSlides = [<NovasLojas/>, <Slide2/>, <Slide4/>]; // Adicionando Slide2 e Slide3

const FlexSlider = () => {
  const [currentSlides, setCurrentSlides] = useState(slides);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCurrentSlides(mobileSlides);
      } else {
        setCurrentSlides(slides);
      }
    };

    handleResize(); // Check on initial render
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleAfterChange = (current) => {
    // Aqui você pode definir a lógica para quando a imagem muda, se necessário
  };

  const settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <FaChevronLeft className="slick-prev" />,
    nextArrow: <FaChevronRight className="slick-next" />,
    autoplay: true,
    autoplaySpeed: 3000,
    afterChange: handleAfterChange,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className='sliderBanner'>
      <Slider {...settings}>
        {currentSlides.map((SlideComponent, index) => (
          <div key={index}>
            {SlideComponent}
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default FlexSlider;
